export const LOCAL_ENV = (process.env.NODE_ENV === 'development' ? 'test' : '')
